import { Filter, UserCheck, MapPin, GraduationCap, Clock } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { useIntersectionObserver } from '@/hooks/use-intersection-observer'
import { cn } from '@/lib/utils'

export function Proposal() {
  const { elementRef, isVisible } = useIntersectionObserver()

  const features = [
    {
      icon: GraduationCap,
      title: 'Disciplina & Formação',
      description:
        'Encontre exatamente o especialista que sua grade curricular precisa.',
    },
    {
      icon: UserCheck,
      title: 'Faixa Etária',
      description:
        'Profissionais com experiência comprovada na etapa de ensino específica.',
    },
    {
      icon: Clock,
      title: 'Carga Horária',
      description:
        'Alinhe disponibilidade de manhã, tarde ou integral desde o início.',
    },
    {
      icon: MapPin,
      title: 'Localização',
      description:
        'Filtre por bairro para garantir pontualidade e menor rotatividade.',
    },
    {
      icon: Filter,
      title: 'Momento da Escola',
      description:
        'Perfis adaptáveis à cultura e metodologia da sua instituição.',
    },
  ]

  return (
    <section ref={elementRef} id="proposta" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy">
            Nossa Proposta: Precisão Cirúrgica
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Receba candidatos compatíveis em poucos dias, não semanas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card
              key={index}
              className={cn(
                'border-slate-100 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 bg-slate-50/50',
                isVisible ? 'animate-fade-in-up' : 'opacity-0',
              )}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardHeader className="pb-2">
                <div className="w-12 h-12 rounded-lg bg-white border border-slate-100 shadow-sm flex items-center justify-center mb-4 text-brand-blue">
                  <feature.icon className="w-6 h-6" />
                </div>
                <CardTitle className="text-xl font-bold text-brand-navy">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-slate-600 leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}

          {/* Last card is the promise */}
          <Card
            className={cn(
              'bg-brand-navy text-white border-none shadow-xl transform lg:scale-105',
              isVisible ? 'animate-fade-in-up' : 'opacity-0',
            )}
            style={{ animationDelay: `${features.length * 100}ms` }}
          >
            <CardContent className="flex flex-col items-center justify-center h-full py-10 text-center">
              <h3 className="text-2xl font-bold mb-4 text-brand-emerald">
                Garantia de Velocidade
              </h3>
              <p className="text-slate-300">
                Otimizamos o processo para que você feche a vaga antes que ela
                vire um problema maior.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}
